import axios from 'axios';
import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/validate/devices";

export const validateDeviceInfo = async (user_agent) => {
	if (!user_agent) {
		throw new Error("Missing user agent");
	}

	Logger.log(this.constructor.name, "validateDeviceInfo()", endpoint);

	try {
		const response = await axios.get(endpoint, {
			params: {
				user_agent
			}
		});

		Logger.log(this.constructor.name, "validateDeviceInfo() response", response);

		const data = response.data;
		return data.result;
	}
	catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/devices.js